import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';

function Dashboard() {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [recentTransactions, setRecentTransactions] = useState([]);

  // This function will load user data
  const loadUserData = async () => {
    try {
      // For now, we'll use a test shop code
      // Later we'll get this from login
      const shopCode = 'TRK123456'; // Replace with actual user's shop code
      
      // Get user details
      const userResponse = await fetch(`http://localhost:5000/api/user/${shopCode}`);
      const userData = await userResponse.json();
      
      if (userData.success) {
        setUser(userData.user);
        setBalance(userData.user.balance);
      }
      
      // Load recent transactions (we'll create this endpoint later)
      const transactionsResponse = await fetch(`http://localhost:5000/api/user/${shopCode}/transactions`);
      const transactionsData = await transactionsResponse.json();
      
      if (transactionsData.success) {
        setRecentTransactions(transactionsData.transactions);
      }
      
    } catch (error) {
      console.error('Error loading dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUserData();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading your dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <h1>🏪 Your TrocaAki Dashboard</h1>
        <p>Welcome back! Manage your shop and payments here.</p>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        
        {/* Left Column - Balance & Quick Actions */}
        <div className="dashboard-left">
          
          {/* Balance Card */}
          <div className="balance-card">
            <h2>💰 Current Balance</h2>
            <div className="balance-amount">
              <span className="amount">{balance.toLocaleString('pt-AO')}</span>
              <span className="currency">Kz</span>
            </div>
            <p>Available to spend or withdraw</p>
            
            <div className="balance-actions">
              <button className="btn btn-success">
                📥 Make Deposit
              </button>
              <button className="btn btn-primary">
                📤 Request Withdrawal
              </button>
            </div>
          </div>

          {/* Quick Actions Card */}
          <div className="quick-actions-card">
            <h2>⚡ Quick Actions</h2>
            <div className="action-buttons">
              <Link to="/pay" className="action-btn">
                <span>💳</span>
                <span>Pay Someone</span>
              </Link>
              <Link to="/receive" className="action-btn">
                <span>📱</span>
                <span>Get Paid</span>
              </Link>
              <Link to="/scan" className="action-btn">
                <span>📷</span>
                <span>Scan to Pay</span>
              </Link>
              <Link to="/shops" className="action-btn">
                <span>🏪</span>
                <span>Find Shops</span>
              </Link>
            </div>
          </div>

        </div>

        {/* Right Column - User Info & Recent Activity */}
        <div className="dashboard-right">
          
          {/* User Info Card */}
          <div className="user-info-card">
            <h2>👤 Your Shop Information</h2>
            {user && (
              <div className="user-details">
                <div className="detail-item">
                  <span className="label">Shop Name:</span>
                  <span className="value">{user.shop_name}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Shop Code:</span>
                  <span className="value code">{user.shop_code}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Owner:</span>
                  <span className="value">{user.name}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Phone:</span>
                  <span className="value">{user.phone}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Status:</span>
                  <span className="value status-active">Active ✅</span>
                </div>
                <div className="detail-item">
                  <span className="label">Premium:</span>
                  <span className="value">
                    {user.is_premium ? 'Active ✅' : 'Not Active'}
                  </span>
                </div>
              </div>
            )}
            <button className="btn btn-outline">
              ✏️ Edit Profile
            </button>
          </div>

          {/* Recent Activity Card */}
          <div className="activity-card">
            <h2>📊 Recent Activity</h2>
            {recentTransactions.length > 0 ? (
              <div className="transactions-list">
                {recentTransactions.slice(0, 5).map((transaction, index) => (
                  <div key={index} className="transaction-item">
                    <div className="transaction-icon">
                      {transaction.type === 'payment' ? '💳' : '📥'}
                    </div>
                    <div className="transaction-details">
                      <div className="transaction-description">
                        {transaction.description}
                      </div>
                      <div className="transaction-meta">
                        <span className="amount">
                          {transaction.amount.toLocaleString('pt-AO')} Kz
                        </span>
                        <span className="time">{transaction.time}</span>
                      </div>
                    </div>
                    <div className={`transaction-status ${transaction.status}`}>
                      {transaction.status}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-transactions">
                <p>No recent transactions yet.</p>
                <p>Start by making your first payment or deposit!</p>
              </div>
            )}
            <Link to="/transactions" className="view-all-link">
              View all transactions →
            </Link>
          </div>

        </div>
      </div>

      {/* Bottom Section - QR Code */}
      <div className="dashboard-bottom">
        <div className="qrcode-section">
          <h2>📱 Your Payment QR Code</h2>
          <p>Customers can scan this code to pay you</p>
          <div className="qrcode-container">
            {user && (
              <img 
                src={`http://localhost:5000/api/qrcode/${user.shop_code}`} 
                alt="Payment QR Code" 
                className="qrcode-image"
              />
            )}
            <div className="qrcode-actions">
              <button className="btn btn-outline">
                📥 Download QR Code
              </button>
              <button className="btn btn-outline">
                📤 Share QR Code
              </button>
              <button className="btn btn-primary">
                🖨️ Print QR Code
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Dashboard;